import { render, staticRenderFns } from "./ReserveInvoiceView.vue?vue&type=template&id=1452b578&"
import script from "./ReserveInvoiceView.vue?vue&type=script&lang=js&"
export * from "./ReserveInvoiceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports